import { LoggerProvider } from '../../logger';

import Container from 'typedi';
import { ResizeObserver as ResizeObserverPolyfill } from '@juggle/resize-observer';
import { WindowToken } from '../../../injection-tokens';
import { ILogger } from '@sparkware/uc-sdk-core';

export class ResizeObserverManager {
    private _resizeObserverInstance: ResizeObserver;
    private _callbacks: ResizeObserverCallback[] = [];

    private _targetElement: HTMLElement;
    protected readonly _logger: ILogger;
    private readonly _window: Window;

    constructor(loggerType: string) {
        this._logger = Container.get(LoggerProvider).getLogger(
            loggerType || 'ResizeObserverManager',
        );
        this._window = Container.get(WindowToken);
        this._resizeObserverInstance = this._create();
    }

    public ObserveElement = (target: HTMLElement, callback: ResizeObserverCallback): void => {
        if (!this._resizeObserverInstance) {
            this._resizeObserverInstance = this._create();
        }

        this._targetElement = target;
        this._logger.debug(
            `ObserveElement: Observing the following element, "${target?.id || 'undefined'}"`,
        );
        this._callbacks.push(callback);

        if (!this._resizeObserverInstance) {
            this._logger.warn(
                'ObserveElement: Resize observer API is not available, callbacks will be called right away',
            );
            callback([], null);
        } else {
            this._resizeObserverInstance.observe(target);
        }
    };

    public Disconnect = () => {
        if (this._resizeObserverInstance) {
            if (this._targetElement) this._resizeObserverInstance.unobserve(this._targetElement);
            this._resizeObserverInstance.disconnect();
            this._resizeObserverInstance = null;
        }

        this._callbacks.pop();
    };

    private _create(): ResizeObserver {
        try {
            if (!this._window.ResizeObserver) {
                this._window.ResizeObserver = ResizeObserverPolyfill;
            }

            const callback = (entries: ResizeObserverEntry[], observer: ResizeObserver) => {
                this._callbacks.forEach((callback) => {
                    callback(entries, observer);
                });
            };

            return new ResizeObserver(callback);
        } catch (e) {
            this._logger.warn(
                'Disconnect: ResizeObserver API does not exist. Will use the fallback mechanism...',
            );

            return null;
        }
    }
}
